import * as React from 'react';
import { connect } from 'react-redux';
import './SpecialDebit.css';
import { setSelectedSpecialDebitDate, setSpecialDebitData, submitScheduleSpecialDebit } from '../../actions/profileActions';
import { Dropdown, Card } from 'react-bootstrap';
import SpecialDebitButton from './SpecialDebitButton/SpecialDebitButton';


class SpecialDebitSchdule extends React.Component<any, any> {

    constructor(props: any) {
        super(props);
        this.state = {
            hasSelectedSpecialDebitDate: false,
            selectedSpecialDebitDate: null,
            dateToggle: false,
        };
        this.handleDateSelection = this.handleDateSelection.bind(this);
        this.handleDateDropdownToggle = this.handleDateDropdownToggle.bind(this);
        this.ScheduleSpecialDebit = this.ScheduleSpecialDebit.bind(this);
    }

    async handleDateSelection(e: any) {
        let selectedDate = this.props.profile.specialDebitDays.filter((item) => item.id == e).map((item) => {
            return item;
        });
        await this.setState({
            hasSelectedSpecialDebitDate: true,
            selectedSpecialDebitDate: selectedDate,
        });
        await this.props.dispatchSetSelectedInfo(selectedDate);
    }

    async handleDateDropdownToggle(e: any) {
        await this.setState({
            dateToggle: !this.state.dateToggle
        });
    }

    async ScheduleSpecialDebit() {
        await this.props.dispatchRaiseSpecialDebit(this.state.selectedSpecialDebitDate);
    }

    componentDidMount() {
        this.setState({ hasSelectedSpecialDebitDate: false });
    }

    render() {
        const { profile, firebase } = this.props;
        const isMobile = window.innerWidth <= 975;
        let dateToday = new Date().getDate().toString();
        dateToday = dateToday.length == 1 ? "0" + dateToday : dateToday;

        let currBank = this.props.profile.bankingDetails.bank ? this.props.profile.bankingDetails.bank : null;
        let currBranch = this.props.profile.bankingDetails.branch ? this.props.profile.bankingDetails.branch : null;
        let currAccount = this.props.profile.bankingDetails.bankAccountType ? this.props.profile.bankingDetails.bankAccountType : null;
        let currAccountNumber = this.props.profile.bankingDetails.accountNumber ? this.props.profile.bankingDetails.accountNumber : "";

        let AvailableSpecialDebitDays = <div></div>;
        if (this.props.profile.specialDebitDays !== undefined) {
            AvailableSpecialDebitDays = this.props.profile.specialDebitDays
                .filter((debitDay) => debitDay.dayOfWeek !== "Sunday" && debitDay.day !== dateToday)
                .map((debitDay) => {
                    return <Dropdown.Item eventKey={debitDay.id} key={debitDay.id} value={debitDay.id}>
                        {debitDay.year}-{debitDay.month}-{debitDay.day}
                    </Dropdown.Item>
                });
        }

        return (
            <Card id="SpecialDebitSchedule" className="content-box-padding-20px-with-box-shadow">
                <Card.Body className="nopa">
                    <div className="container nopa">
                        <p className="SpecialDebitTitle mb-0">Schedule a special debit</p>
                        <hr />
                        <div className="SpecialDebitAmount">
                            <span className="outstandingTitle">Total amount outstanding</span>
                            <br />
                            <span className="outstandingAmount">{this.props.profile.currencySymbol} {this.props.profile.specialDebitAmount}</span>
                        </div>
                        <hr />
                        <div className="form-row mb-lg-4 disabled-opacity">
                            <div className="col-lg-6 col-12 mb-3 mb-lg-0">
                                <label className="Set-up-labels">Account type</label>
                                <input disabled={this.props.profile.policyId !== ""} type="text" className="form-control mb-2 white-background arrow-right-disabled sd-inp" placeholder="Account type" name="accountType" value={currAccount} />
                            </div>
                            <div className="col-lg-6 col-12 mb-3 mb-lg-0">
                                <label className="Set-up-labels">Account no.</label>
                                <input disabled={this.props.profile.policyId !== ""} type="text" className="form-control mb-2 white-background sd-inp" placeholder="Account no." name="accountNumber" value={currAccountNumber} />
                            </div>
                        </div>
                        <div className="form-row mb-lg-4 disabled-opacity">
                            <div className="col-lg-6 col-12 mb-3 mb-lg-0">
                                <label className="Set-up-labels">Bank</label>
                                <input disabled={this.props.profile.policyId !== ""} type="text" className="form-control mb-2 white-background arrow-right-disabled sd-inp" placeholder="Bank" name="bank" value={currBank} />

                            </div>
                            <div className="col-lg-6 col-12 mb-3 mb-lg-0">
                                <label className="Set-up-labels">Branch</label>
                                <input disabled={this.props.profile.policyId !== ""} type="text" className="form-control mb-2 white-background sd-inp" placeholder="Branch" name="branch" value={currBranch} />
                            </div>
                        </div>
                        <div className="form-row mb-lg-4">
                            <div className="col-lg-6 col-12 mb-lg-0">
                                <label className="Set-up-labels">{!this.state.hasSelectedSpecialDebitDate ? "Select special debit date" : "Special debit date"}</label>
                                <Dropdown id="ChooseItemSpecialDebit" className="schedule ml-0"
                                    onSelect={this.handleDateSelection}
                                    onToggle={this.handleDateDropdownToggle}>
                                    <Dropdown.Toggle id="dropdown-basic" >
                                        <>
                                            {this.state.hasSelectedSpecialDebitDate &&
                                                <>
                                                    <div className="row noma black align-items-center">
                                                        <div className="text-left col nopa align-self-center">
                                                            {this.state.selectedSpecialDebitDate[0].year}-{this.state.selectedSpecialDebitDate[0].month}-{this.state.selectedSpecialDebitDate[0].day}
                                                        </div>
                                                        <div className="text-right arrow-col align-self-center">
                                                        <img className="dropdownArrowImg" src={!this.state.dateToggle ? '/my-policy/Images/Claims/down-arrow.png' : '/my-policy/Images/EmergencyAssist/icons-arrow-dropdown-up-grey-24-px.png'} />
                                                        </div>
                                                    </div>
                                                </>
                                            }
                                            {!this.state.hasSelectedSpecialDebitDate &&
                                                <>
                                                    <div className="row noma black align-items-center">
                                                        <div className="text-left col nopa align-self-center">
                                                            Select date
                                                        </div>
                                                        <div className="text-right arrow-col align-self-center">
                                                        <img className="dropdownArrowImg" src={!this.state.dateToggle ? '/my-policy/Images/Claims/down-arrow.png' : '/my-policy/Images/EmergencyAssist/icons-arrow-dropdown-up-grey-24-px.png'} />
                                                        </div>
                                                    </div>
                                                </>
                                            }
                                        </>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu title="Choose an item" id="special-debit-dropdown">
                                        {AvailableSpecialDebitDays}
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </div>
                        <hr />
                        <p>
                            Please make sure that you have enough funds in your bank account so that the debit order can go through. <br /><br />
                            Do you confirm that the account specified belongs to you and that you authorise 'King Price' to debit the amount of <span className="text-red">{this.props.profile.currencySymbol} {this.props.profile.specialDebitAmount}</span>? The amount deducted will reflect as King Price on your bank statement.
                        </p>
                        {!isMobile &&
                            <div className="text-center pt-4">
                                <button className="btn btn-solid-green w-50" disabled={!this.state.hasSelectedSpecialDebitDate} id="SpecialDebitButton" onClick={() => this.ScheduleSpecialDebit()} >Schedule special debit</button>
                            </div>
                        }
                        {isMobile &&
                            <SpecialDebitButton />
                        }
                        <div className="text-center pt-4 pb-3">
                            <img src="./Images/icon-secure-new.png" />
                        </div>
                    </div>
                </Card.Body>
            </Card>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        firebase: state.firebase,
        profile: state.profile
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchSetSpecialDebitData: (hasSpecialDebit, specialDebitDate) => dispatch(setSpecialDebitData(hasSpecialDebit, specialDebitDate)),
        dispatchRaiseSpecialDebit: (selectedSpecialDebitDate) => dispatch(submitScheduleSpecialDebit(selectedSpecialDebitDate)),
        dispatchSetSelectedInfo: (selectedItem) => dispatch(setSelectedSpecialDebitDate(selectedItem)),
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(SpecialDebitSchdule);